import { Divider, FileWrapper } from './styles';
import { useFormContext } from 'react-hook-form';
import { RecordFilter } from '@/types/api';
import FileItem from '@/components/Record/SubjectContent/AttachmentFile/FileContent/FileItem';
import React from 'react';
import usePlatform from '@/components/Record/hooks/usePlatform';
import AttachmentButton from '@/components/Record/AttachmentButton';
import { useDeleteAudioFile } from '@/hooks/apiHooks';

const UploadList = () => {
  const { watch, setValue, getValues } = useFormContext<RecordFilter>();
  const docId = getValues('docId');
  const files = watch('recordings') || [];

  if (files.length === 0) return null;

  const handleDelete = async (uuid: string) => {
    try {
      await useDeleteAudioFile(docId, uuid);
      const updated = files.filter((item, _) => item.uuid !== uuid);
      setValue('recordings', updated);
    } catch (e) {
      console.log(e);
    }
  };
  const { isMobilePath } = usePlatform();

  return (
    <FileWrapper mobileMode={isMobilePath}>
      {isMobilePath ? (
        files.map((item) => (
          <FileItem
            key={item.uuid}
            fileName={item.name}
            handleDelete={() => handleDelete(item.uuid)}
          />
        ))
      ) : (
        <>
          <Divider />
          {files.map((item, index) => (
            <AttachmentButton
              key={`audioAttach-${item.name}-${index}`}
              data={item}
              handleDelete={() => handleDelete(item.uuid)}
            />
          ))}
        </>
      )}
    </FileWrapper>
  );
};

export default UploadList;
